import React from "react";
import { Notes } from "us.collection/components";
import { EntityType } from "us.collection/constants";

interface INotes {
  caseNo: number;
}

const Cnt_Notes: React.FC<INotes> = (props) => {

  return (
    <Notes
      entityType={EntityType.CREDITOR}
      entityId={props.caseNo}
      {...props}
    />
  );
};

export default Cnt_Notes;
